import { DateTime } from 'luxon';

export const formatDate = (dateTime: string) => {
    if (!dateTime) return;

    if (typeof dateTime !== 'string') {
        const date = new Date(dateTime);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        dateTime = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
    }

    return DateTime.fromISO(dateTime, { zone: 'utc' }).setZone('Europe/Kyiv').toFormat('yyyy-MM-dd HH:mm:ss');
};
